import { useState } from 'react';
import { Columns, FoldPanel, Select, Specimens } from '@src/components';

const DELIVERY = [
  { value: 'post', label: 'Send by post' },
  { value: 'office', label: 'Leave it in the office' },
  { value: 'meetup', label: 'Hand it over in person' },
];

const BUDGETS = [
  { value: '10-20', label: '$10–20' },
  { value: '20-50', label: '$20–50' },
  { value: '50-100', label: '$50–100' },
  { value: 'surprise', label: 'Surprise me' },
];

const THEMES = [
  { value: 'edges', label: 'Soft edges' },
  { value: 'midnight', label: 'Midnight' },
  { value: 'paper', label: 'Paper' },
];

export function SelectSection() {
  const [delivery, setDelivery] = useState('post');
  const [deliveryOpen, setDeliveryOpen] = useState(false);
  const [budget, setBudget] = useState('');
  const [budgetOpen, setBudgetOpen] = useState(false);
  const [theme, setTheme] = useState('edges');
  const [themeOpen, setThemeOpen] = useState(false);
  const [aligned, setAligned] = useState('edges');
  const [alignedOpen, setAlignedOpen] = useState(false);

  return (
    <FoldPanel
      id="selects"
      title="Selects"
      hint="Same Field chrome as Input, with a chevron and a list. Click an option to choose it."
      example={`<Select
  label="Delivery"
  value={delivery}
  options={options}
  onValueChange={setDelivery}
  open={open}
  onOpenChange={setOpen}
  hint="Post, office, or in person."
/>`}
    >
      <Specimens
        label="States"
        note="Hover tints the border, focus is blueberry, error is red. Pick a delivery or a budget."
      >
        <Columns columns="fill" gap={5}>
          <Select
            label="Delivery"
            value={delivery}
            options={DELIVERY}
            onValueChange={setDelivery}
            open={deliveryOpen}
            onOpenChange={setDeliveryOpen}
            hint="Post, office, or in person."
          />
          <Select
            label="Budget"
            value={budget}
            options={BUDGETS}
            onValueChange={setBudget}
            placeholder="Choose a range"
            open={budgetOpen}
            onOpenChange={setBudgetOpen}
            error={budget ? undefined : 'Pick a budget before the draw.'}
          />
          <Select
            label="Locked"
            value="office"
            options={DELIVERY}
            onValueChange={() => undefined}
            disabled
            hint="Archived games are read-only."
          />
        </Columns>
      </Specimens>

      <Specimens
        label="Alignment"
        note="reserveSpace keeps a labelless select level with its neighbour."
      >
        <Columns columns="fill" gap={5}>
          <Select
            label="Theme"
            value={theme}
            options={THEMES}
            onValueChange={setTheme}
            open={themeOpen}
            onOpenChange={setThemeOpen}
          />
          <Select
            value={aligned}
            options={THEMES}
            onValueChange={setAligned}
            open={alignedOpen}
            onOpenChange={setAlignedOpen}
            reserveSpace
            placeholder="No label, still aligned"
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
